import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7859848d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hstack detection" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, " 系统服务版本 ", -1))
const _hoisted_3 = { class: "hstack center" }
const _hoisted_4 = {
  key: 0,
  class: "spinner"
}
const _hoisted_5 = { class: "btnText" }

import { ref, computed } from 'vue'
import GradientButton from '@remote/components/GradientButton.vue'
import { useHeziVersionStore } from '@remote/store/version'
import Modal from '@remote/components/modal'
import { toast } from '@remote/utils/dialog'
import { checkState } from '@remote/store/utils'
import { isLargeViewPort } from '@remote/utils/base'
import type { IUpdateModalRef } from './type.d'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

function logs (..._args: any[]) {
  console.log('[VersionDetection]', ..._args)
}

const store = useHeziVersionStore()

const checking = ref(false)
const updating = computed(() => {
  return store.isUpdating
})
const checkable = computed(() => {
  return !(checking.value || updating.value)
})

const onCheck = async () => {
  if (!checkable.value) return
  // 网络、设备离线等异常检测
  if (checkState(true, true, false, false)) return

  checking.value = true
  try {
    const { hasNewVersion, versionStore } = await store.checkVersion()
    if (hasNewVersion) {
      // 弹窗提示更新
      logs('弹窗提示更新:', versionStore)
      let $modal: IUpdateModalRef | null = null
      const backdrop = isLargeViewPort() ? false : true
      const closeModal = Modal.showVersionUpdateModal({
        from: 'ServicePage',
        closeable: true,
        backdrop,
        versionStore,
        getRef: (ref) => $modal = ref,
        onUpdate: (updateList) => {
          logs('待升级服务:', updateList)
          if (backdrop) toast('服务升级中...')
          store.updateVersion({
            onSuccess: () => {
              if (!backdrop) {
                $modal?.setProgress(100)
                setTimeout(() => {
                  closeModal()
                  toast({ type: 'success', message: '服务升级成功' })
                }, 500)
              } else {
                toast({ type: 'success', message: '服务升级成功' })
              }
            },
            onError: () => {
              if (!backdrop) {
                setTimeout(() => {
                  closeModal()
                  toast({ type: 'error', message: '服务升级失败' })
                }, 500)
              } else {
                toast({ type: 'error', message: '服务升级失败' })
              }
            },
          })
        },
      })
    } else {
      toast('当前版本已是最新')
    }
  } catch (err) {
    console.error(err)
    toast('检查更新发生错误')
  } finally {
    checking.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(GradientButton, {
      class: "button",
      disabled: !_unref(checkable),
      onClick: _withModifiers(onCheck, ["stop"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_3, [
          ((checking.value || _unref(updating)))
            ? (_openBlock(), _createElementBlock("span", _hoisted_4))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(updating) ? '更新中' : '检查更新'), 1)
        ])
      ]),
      _: 1
    }, 8, ["disabled", "onClick"])
  ]))
}
}

})